import { Col, List, Row } from 'antd';
import dayjs from 'dayjs';
import utc from 'dayjs-plugin-utc';
import React from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { HelpText } from '../../../views/typography';
import Button from '../../../views/StyledButton';
import dateProps from '../dateProps';
import toMidnight from '../toMidnight';

dayjs.extend(utc);

export default ({ state, actions }) => {
  const now = dayjs().utc().toISOString();

  const firstOfMonth = dayjs().utc()
    .startOf('day')
    .startOf('month')
    .toISOString();

  const lastMonth = dayjs()
    .utc()
    .subtract(1, 'month')
    .startOf('month')
    .startOf('day')
    .toISOString();

  const lastYear = dayjs().utc()
    .subtract(1, 'year')
    .startOf('month')
    .startOf('day')
    .toISOString();

  return (<div>
    <h2>Sample values:</h2>
    <List bordered size="small">
      <List.Item>
        <Row style={({width: '100%'})}>
          <Col xs={24} sm={8}>Custom Date:</Col>
          <Col xs={24} sm={16}>
            <span className="small-date">
              {<DayPickerInput
                locale="us"
                dayPickerProps={dateProps(actions.chooseDateFromPicker)}
                selectedDays={state.datePickerDate}
              />}
            </span>
          </Col>
        </Row>
      </List.Item>
      <List.Item><Button type="link" block align="left" onClick={() => actions.setValue(now)}>
        {now} (now)
      </Button>
      </List.Item>
      <List.Item><Button type="link" block align="left" onClick={() => actions.setValue(firstOfMonth)}>
        {firstOfMonth} (start of
          month)
      </Button>
      </List.Item>
      <List.Item><Button type="link" block align="left" onClick={() => actions.setValue(lastMonth)}>
        {lastMonth} (start of last
          month)
      </Button>
      </List.Item>
      <List.Item><Button type="link" block align="left" onClick={() => actions.setValue(lastYear)}>
        {lastYear} (start of last year)
      </Button>
      </List.Item>
    </List>
  </div>);
};
